function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import gettext from 'js-utils/gettext';
import Button from '../button/Button';
import { STYLE_FILL, SIZE_BLOCK } from '../button/constants';
import EventCardContent from './_internal/EventCardContent';
import { LIST_TYPE, STANDARD_STYLE, IMAGE_STYLE_FIXED } from './_internal/constants';
import { parseDate } from 'js-utils/datetime';
import DateThumbnail from '../dateThumbnail/DateThumbnail';
export var SaveModalContent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SaveModalContent, _React$Component);

  function SaveModalContent() {
    _classCallCheck(this, SaveModalContent);

    return _possibleConstructorReturn(this, _getPrototypeOf(SaveModalContent).apply(this, arguments));
  }

  _createClass(SaveModalContent, [{
    key: "render",
    // TODO: Add prop-types
    value: function render() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          id = _this$props.id,
          title = _this$props.name,
          imageUrl = _this$props.imageUrl,
          startDate = _this$props.startDate,
          isLazyImage = _this$props.isLazyImage;
      var commonProps = {
        title: title,
        imageUrl: imageUrl,
        isLazyImage: isLazyImage,
        style: STANDARD_STYLE,
        type: LIST_TYPE,
        imageStyle: IMAGE_STYLE_FIXED
      };
      return React.createElement("div", {
        className: "eds-g-cell eds-g-cell-md-6-12 eds-g-offset-md-3-12 eds-g-cell-sm-8-12 eds-g-offset-sm-2-12 eds-g-cell-1-1 save-interstitial"
      }, React.createElement("div", {
        className: "eds-text--center"
      }, React.createElement("h1", {
        className: "eds-text-hm eds-text-weight--light eds-text-color--ui-800"
      }, gettext('Sign in to save this event'))), React.createElement("div", {
        className: "eds-l-mar-top-8 eds-align--center-horizontal"
      }, React.createElement("div", {
        className: "eds-l-pad-vert-4 eds-show-up-sw"
      }, React.createElement(EventCardContent, _extends({
        extraContent: React.createElement(DateThumbnail, {
          date: startDate
        })
      }, commonProps))), React.createElement("div", {
        className: "eds-l-pad-vert-4 eds-show-down-sm"
      }, React.createElement(EventCardContent, _extends({
        subContentOne: gettext('%(month)s %(day)s', parseDate(startDate))
      }, commonProps)))), React.createElement("p", {
        className: "eds-l-mar-top-10 eds-l-mar-hor-4 eds-text--center eds-text-color--ui-600"
      }, gettext('Save it, find it, and we\'ll show you other events like it')), React.createElement("div", {
        className: "eds-l-mar-top-6 eds-align--center-horizontal"
      }, React.createElement("div", {
        className: "save-interstitial__continue-button"
      }, React.createElement(Button, {
        style: STYLE_FILL,
        onClick: onClick.bind(null, id),
        size: SIZE_BLOCK
      }, gettext('Continue')))));
    }
  }]);

  return SaveModalContent;
}(React.Component);